// The browser's name for the page: "Sign in · TUNE Analytics".
import { useEffect } from 'react';

export const APP_NAME = 'TUNE Analytics';

export function usePageTitle(title: string): void {
  useEffect(() => {
    document.title = title ? `${title} · ${APP_NAME}` : APP_NAME;
  }, [title]);
}
